
(function () {
  let pixelRatio = window.devicePixelRatio;

  function setWidthVariable() {
    let sz = 1;
    let ww = window.outerWidth - 8;

    if (/chrome/i.test(navigator.userAgent)) {
      ww = window.innerWidth * (window.devicePixelRatio / pixelRatio);
    }

    if (ww < 375) {
      sz = ww / 375;
    } 
    else if (ww > 1640) {
      sz = 1 + ((ww - 1640) / 1640 * 0.3);
    } 
    else {
      sz = 1;
    }

    document.documentElement.style.setProperty('--sw', sz);
  }

  window.addEventListener('resize', setWidthVariable);
  window.addEventListener('orientationchange', setWidthVariable);
  setWidthVariable();
})();
